import { useMemo } from "react";

const INTERACTIVE_PRDOUCTS_CLASS = "interactive-products-item-container__";

export const getFullClassByPageIndex = (pageIndex) =>
	`${INTERACTIVE_PRDOUCTS_CLASS}${pageIndex}`;

export const useContainersFromProductsByPages = (productsByPages) => {
	const containers = useMemo(() => {
		const collectedElementsByPageIndex = Object.keys(productsByPages)
			.map((pageIndex) => {

                const indexNum = parseInt(pageIndex);

				if (isNaN(indexNum)) {
					console.error(
						`[INTERACTIVE PRODUCTS] Page index \`${pageIndex}\` on productsByPages obj is not a number.`
					);
					return null;
				}

				const element = document.querySelector(
					`.${getFullClassByPageIndex(pageIndex)}`
				);

				if (!element) {
					console.error(
						`[INTERACTIVE PRODUCTS] Container for page ${pageIndex} is not defined.`
					);
					return null;
				}

				return { element, pageIndex };
			})
			.filter((val) => val !== null)
			.reduce((elementsByPages, current) => {
				const { element, pageIndex } = current;
				elementsByPages[pageIndex] = element;

                return elementsByPages;
			}, {});

		return collectedElementsByPageIndex;
	}, [productsByPages]);

	return { containers };
};
